import { render, staticRenderFns } from "./A4Print.vue?vue&type=template&id=9c7687a8&scoped=true"
import script from "./A4Print.vue?vue&type=script&lang=js"
export * from "./A4Print.vue?vue&type=script&lang=js"
import style0 from "./A4Print.vue?vue&type=style&index=0&id=9c7687a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7687a8",
  null
  
)

export default component.exports